import {
  SPACE_USER_PATHS,
  createSpaceUserApi,
  type SpaceRequest,
  type SpaceTransport,
} from '@space/user-core'
import { httpClient } from '@/shared/api/httpClient'

/**
 * Ядро пользователя Space поверх httpClient Gonka. Запросы собирает ядро,
 * а 401 → выход, тосты JSMessage и токен остаются поведением httpClient.
 */
const gonkaTransport: SpaceTransport = {
  request<T>(request: SpaceRequest): Promise<T> {
    if (request.method === 'GET') return httpClient.get<T>(request.path)
    if (request.method === 'DELETE') {
      return request.json
        ? httpClient.delete<T>(request.path, {
            body: JSON.stringify(request.json),
          })
        : httpClient.delete<T>(request.path)
    }
    // postRaw ловит dev-заголовок с кодом из письма (devEmailCodeCapture).
    if (request.path === SPACE_USER_PATHS.initActionSession) {
      return httpClient
        .postRaw<T>(request.path, request.form)
        .then(({ data }) => data)
    }
    return httpClient.post<T>(request.path, request.form ?? request.json)
  },
}

/** Запросы попытки, которую можно отменить (isCurrent): отменённая не трогает авторизацию. */
const guardedTransport = (isCurrent: () => boolean): SpaceTransport => ({
  request<T>(request: SpaceRequest): Promise<T> {
    if (!request.form && !request.json && request.method === 'GET') {
      return httpClient.guardedRequest<T>(request.path, isCurrent)
    }
    const body = request.form ?? JSON.stringify(request.json)
    return httpClient.guardedRequest<T>(request.path, isCurrent, {
      method: request.method,
      body,
    })
  },
})

export const spaceUser = createSpaceUserApi(gonkaTransport)

export const spaceUserFor = (isCurrent?: () => boolean) =>
  isCurrent ? createSpaceUserApi(guardedTransport(isCurrent)) : spaceUser
